import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"


//import "./assets/css/style.css";
import "aos/dist/aos.css";
import AOS from "aos";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Checkout from "./Pages/Checkout";
import Product from "./Pages/Product";
import Orders from "./Pages/Orders";
import { Toaster } from "react-hot-toast";
import Wishlist from "./Pages/Wishlist";

import Profile from "./Pages/Profile";
import Addresses from "./Pages/Addresses";
import AdminLogin from "./Pages/AdminLogin";
import ReactWhatsapp from "react-whatsapp";
import WhatsAppButton from "./components/WhatsappInt";
import ContactButton from "./components/ContactIcon";
import OrderSucc from "./Pages/OrderSuccessPage";
import RefundPolicy from "./Pages/RefundPolicy";
import ShippingPolicy from "./Pages/ShippingPolicy";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsandConditions from "./Pages/TermsandConditions";
function App() {
  React.useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  return (
    <Router>
        {/* <ReactWhatsapp number="1-212-736-5000" message="Hello World!!!" /> */}
 <Toaster position="top-right" reverseOrder={false} />
 <WhatsAppButton/>
 <ContactButton/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About/>} /> 
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/shop" element={<Shop/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/product/:guid" element={<Product />} />
        <Route path="/register" element={<Register/>} />
        <Route path="/wishlist" element={<Wishlist/>} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/address" element={<Addresses/>} />
        <Route path="/admin-login" element={<AdminLogin/>} />
        <Route path="/order-summary" element={<OrderSucc/>} />
        <Route path="/refund-policy" element={<RefundPolicy/>} />
        <Route path="/shipping-policy" element={<ShippingPolicy/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/termsandconditions" element={<TermsandConditions/>} />
      </Routes>
    
    </Router>
  );
}

export default App;
